import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import AppStore from "@/store/modules/AppStore";
import AuthorizationStore from "@/store/modules/AuthorizationStore";
import PayoutMethodStore from "@/store/modules/PayoutMethodStore";
import ActiveCountryStore from "@/store/modules/ActiveCountryStore";
import RecordStore from "@/store/modules/RecordStore";
import FeesStore from "@/store/modules/FeesStore";
import AnalyzerStore from "@/store/modules/AnalyzerStore";
import ProviderRatesStore from "@/store/modules/ProviderRatesStore";
import UsersStore from "@/store/modules/UsersStore";
import AuditLogStore from "@/store/modules/AuditLogStore";
import PayinFeesStore from "@/store/modules/PayinFeesStore";

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    AppStore,
    AuthorizationStore,
    PayoutMethodStore,
    ActiveCountryStore,
    RecordStore,
    FeesStore,
    AnalyzerStore,
    ProviderRatesStore,
    UsersStore,
    AuditLogStore,
    PayinFeesStore
  }
});
